<template>
  <div v-if="discountQuantityBreaks.length" class="DiscountQuantityBreaks mb-24">
    <div class="type-tagline text-text-subtle mb-8 uppercase">{{ $t('buyMore.multiCampaign-headline') }}</div>
    <div
      v-for="(breakpoint, index) in discountQuantityBreaks"
      :key="index"
      class="type-headline-sm p-16 mb-8 flex items-center justify-between gap-12"
      :class="{
        'bg-bg-subtle': !breakpoint.reached,
        'bg-bg-success': breakpoint.reached
      }"
    >
      <div class="flex items-center gap-12">
        <img
          v-if="breakpoint.reached"
          src="/icons/check-badge-success.svg"
          class="w-16 h-16"
          alt=""
        >
        <img
          v-else
          src="/icons/sale.svg"
          class="w-16 h-16"
          alt=""
        >
        <div>
          {{ $t(langKey, { percent: breakpoint.discountPercentage, num: breakpoint.quantity }) }}
          <span v-if="breakpoint.areaPrice"> = {{ NP.times(breakpoint.areaPerPackage, breakpoint.quantity) }} {{ breakpoint.unitDisplay }}
          </span>
        </div>
      </div>
      <div v-if="breakpoint.areaPrice" class="text-right">
        {{ useLocalizedCurrency(breakpoint.areaPrice) }} / {{ breakpoint.unitDisplay }}
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { DiscountQuantityBreak } from '~/constants/types/norce';
import { useLocalizedCurrency } from '~/composeables/useLocalizedCurrency';
import NP from 'number-precision';
import { Category } from '~/constants/types/algolia';

const { $t } = useNuxtApp();

const props = defineProps<{
  discountQuantityBreaks: DiscountQuantityBreak[],
  categories: Category[]
}>();

/**
 * Creates the ability to have a separate text for certain categories,
 * example
 * "discountBreakpoint.Accessories"
 *
 */
const langKey = computed(()=> {
  const exception = props.categories.find((category) => {
    return $t(`discountBreakpoint.${category.code}`) !== `discountBreakpoint.${category.code}` && $t(`discountBreakpoint.${category.code}`) !== '';
  });

  if (exception) {
    return `discountBreakpoint.${exception.code}`;
  }

  return 'discountBreakpoint';
});

</script>

<style scoped lang="postcss">
</style>
